// Module
var code = "<a class=\"link-type-control-data\" data-bind=\"\r\n\tattr: {href: _value ? _value : undefined},\r\n\tcss: {disabled: !_value},\r\n\ttooltip: {content: _value}\" target=\"_blank\"> <i class=\"icon\" data-bind=\" css : {[_icon || 'fa fa-linkedin'] : true}, style: {'color': _labelStyle}\"></i> </a>";
// Exports
export default code;